module.exports = __webpack_public_path__ + "static/media/logo.5a5ae6cd.png";